import z from "zod";

export const meterDataSchema = z.object({
  label: z.string().optional(),
  value: z.coerce.number(),
  min: z.coerce.number().optional(),
  max: z.coerce.number().optional(),
});

export type MeterDataProps = z.infer<typeof meterDataSchema>;
